import { obterImagemCampanha } from '@/service/api/endpoints/campanhas'
import { useEffect, useState } from 'react'

interface IProps {
    campanhaId: string
    imagemId: string
    alt?: string
}

export function ImagemCampanha({ campanhaId, imagemId, alt }: IProps) {
    const [url, setUrl] = useState<string>()

    useEffect(() => {
        let objectUrl: string | undefined
        let cancelado = false

        obterImagemCampanha(campanhaId, imagemId)
            .then(blob => {
                if (cancelado) return

                objectUrl = URL.createObjectURL(blob)
                setUrl(objectUrl)
            })
            .catch(() => {
                if (!cancelado) setUrl(undefined)
            })

        return () => {
            cancelado = true
            // Limpa o state junto com o blob: manter a URL revogada no state
            // deixaria a imagem quebrada na tela até a nova busca responder.
            setUrl(undefined)
            if (objectUrl) URL.revokeObjectURL(objectUrl)
        }
    }, [campanhaId, imagemId])

    if (!url) return null

    return (
        <img
            loading="lazy"
            src={url}
            alt={alt ?? ''}
            className="max-w-full rounded-md"
        />
    )
}
